import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DashboardTemplate from '../../Common/DashboardTemplate';
import { Button, CircularProgress, TextField } from '@material-ui/core';
import { ServiceLocator } from '../../../Services/ServiceLocator';
import SortableTableHeader from '../../Common/SortableTableHeader';

const styles = theme => ({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    toolbarLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        flex: 1,
    },
    toolbarRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
});

class ProductListings extends Component {
    state = {
        loading: true,
        listings: [],
        search: '',
        sortField: 'listingKey',
        sortDirection: 'asc',
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        ServiceLocator.Instance.getProductListingService()
            .getAll()
            .then(listings => this.setState({ listings, loading: false }))
            .catch(err => {
                window.$alertError(err.message || 'Failed to load product listings');
                this.setState({ loading: false });
            });
    };

    handleSort = (field) => {
        this.setState(prev => ({
            sortField: field,
            sortDirection: prev.sortField === field && prev.sortDirection === 'asc' ? 'desc' : 'asc',
        }));
    };

    openListing = (id) => {
        this.props.history.push(`/admin/product-listings/${id}`);
    };

    createListing = () => {
        this.props.history.push('/admin/product-listings/new');
    };

    getFilteredListings = () => {
        const { listings, search, sortField, sortDirection } = this.state;
        const term = search.trim().toLowerCase();
        let rows = listings.filter(l =>
            !term ||
            (l.listingKey || '').toLowerCase().includes(term) ||
            (l.title || '').toLowerCase().includes(term) ||
            (l.slug || '').toLowerCase().includes(term)
        );

        rows.sort((a, b) => {
            const av = (a[sortField] ?? '').toString().toLowerCase();
            const bv = (b[sortField] ?? '').toString().toLowerCase();
            if (av < bv) return sortDirection === 'asc' ? -1 : 1;
            if (av > bv) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });

        return rows;
    };

    render() {
        const { classes } = this.props;
        const { loading, search } = this.state;
        const rows = this.getFilteredListings();

        return (
            <DashboardTemplate title="Product Listings" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container">
                        <div className={`${classes.toolbar} toolbar-responsive`} style={{ marginBottom: '20px' }}>
                            <div className={`${classes.toolbarLeft} toolbar-left`}>
                                <TextField
                                    value={search}
                                    onChange={e => this.setState({ search: e.target.value })}
                                    label="Search listings..."
                                    variant="outlined"
                                    className="search-field"
                                    style={{ minWidth: '300px' }}
                                />
                            </div>
                            <div className={`${classes.toolbarRight} toolbar-right`}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.createListing}
                                    className="success-button-lg action-button"
                                    style={{ minWidth: 120 }}
                                >
                                    New listing
                                </Button>
                            </div>
                        </div>

                        {loading ? (
                            <center style={{ padding: '40px 0' }}><CircularProgress /></center>
                        ) : (
                            <>
                                <div className="parts-table-container">
                                    <table className="parts-table">
                                        <thead>
                                            <tr>
                                                <SortableTableHeader field="listingKey" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort}>Listing Key</SortableTableHeader>
                                                <SortableTableHeader field="title" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort}>Title</SortableTableHeader>
                                                <SortableTableHeader field="slug" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort}>Slug</SortableTableHeader>
                                                <th>Published</th>
                                                <th>Discontinued</th>
                                                <th>Options</th>
                                                <th>SKUs</th>
                                                <th style={{ minWidth: 80 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map(row => (
                                                <tr key={row.id} style={{ cursor: 'pointer' }} onClick={() => this.openListing(row.id)}>
                                                    <td>{row.listingKey}</td>
                                                    <td>{row.title}</td>
                                                    <td>{row.slug}</td>
                                                    <td>{row.isPublished ? 'Yes' : 'No'}</td>
                                                    <td>{row.isDiscontinued ? 'Yes' : 'No'}</td>
                                                    <td>{row.optionCount}</td>
                                                    <td>{row.skuCount}</td>
                                                    <td>
                                                        <Button
                                                            size="small"
                                                            className="success-button-lg"
                                                            onClick={(e) => { e.stopPropagation(); this.openListing(row.id); }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {rows.length === 0 && (
                                    <p style={{ textAlign: 'center', padding: '24px 0', color: '#666' }}>
                                        No product listings yet. Click <strong>New listing</strong> to create one.
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </DashboardTemplate>
        );
    }
}

ProductListings.propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductListings);
